import {
  IonGrid,
  IonCol,
  IonRow,
  IonContent,
  IonIcon,
  IonText,
  IonPage,
  IonItem,
  IonLabel,
  IonInput,
  IonFooter,
  IonSegment,
  IonSegmentButton,
  IonList,
  IonTextarea,
  IonToast,
  useIonViewDidEnter,
  isPlatform
} from '@ionic/react';
import { save, share, trashBin } from 'ionicons/icons';
import './PrayerUpdatePage.scss';
import React, { useEffect, useRef, useState } from 'react';
import PrayerStatus, { PrayerStatusValues, PrayerStatusNames } from '../../data/PrayerStatus';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import IRouteInfo from '../../interfaces/IRouteInfo';
import PageHeader from '../../components/PageHeader/PageHeader';
import { useParams, useHistory } from 'react-router-dom';
import IPrayer from '../../interfaces/IPrayer';
import PrayerService from '../../services/PrayerService';
import PostTypes from '../../data/PostTypes';
import DismissibleCard from '../../components/DismissibleCard/DismissibleCard';
import { AppMessages } from '../../data/AppMessages';
import DismissibleMessageService from '../../services/DismissibleMessageService';
import IDismissibleMessage from '../../interfaces/IDismissibleMessage';
import { useSelector } from 'react-redux';
import { SelectLoginStatus } from '../../store/UserSlice';
import { Keyboard } from '@capacitor/keyboard';

const PrayerUpdate: React.FC<IRouteInfo> = (props) => {

  const nowMilliseconds = Date.now();
  const newPrayer: IPrayer = {
    id: 0,
    title: '',
    description: '',
    status: PrayerStatus.active,
    createdDate: new Date(nowMilliseconds),
    modifiedDate: new Date(nowMilliseconds),
    order: nowMilliseconds,
  };

  const history = useHistory();
  const { id } = useParams<{ id: string; }>();
  console.log('prayerId', id)
  const [isNewPrayer, setIsNewPrayer] = useState(true);
  const [selectedPrayer, setSelectedPrayer] = useState(newPrayer);
  const [createdDate, setCreatedDate] = useState(newPrayer.createdDate)
  const [selectPrayerStatus, setSelectPrayerStatus] = useState<PrayerStatusValues | string>(newPrayer.status);
  const [prayerTitle, setPrayerTitle] = useState(newPrayer.title);
  const [prayerDescription, setPrayerDescription] = useState(newPrayer.description);
  const [displayToastSuccess, setDisplayToastSuccess] = useState(false);
  const [displayToastFailed, setDisplayToastFailed] = useState(false);
  const [toastSuccessMessage, setToastSuccessMessage] = useState('Success: Added New Prayer.');
  const [hideShareAndDeleteLink, setHideShareAndDeleteLink] = useState(false);
  const [hidePrayStorageMessage, setHidePrayStorageMessage] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const LoggedIn = useSelector(SelectLoginStatus);
  const descriptionContainer = useRef<HTMLIonRowElement | null>(null);

  useIonViewDidEnter(() => {
    if(!isNaN(parseInt(id))){
      PrayerService.getPrayer(parseInt(id)).then(response => {
        if(response.Success) {
          setSelectedPrayer(response.Data!);
          setSelectPrayerStatus(response.Data?.status!);
          setPrayerTitle(response.Data?.title!);
          setPrayerDescription(response.Data?.description!);
          setCreatedDate(response.Data?.createdDate!);
          setHideShareAndDeleteLink(false);
          setIsNewPrayer(false);
        }
      });
    } else {
      setIsNewPrayer(true);
      setHideShareAndDeleteLink(true);
      setPrayerTitle('');
      setPrayerDescription('');
      setSelectPrayerStatus(PrayerStatus.active);
    }
  }, [id]);


  useEffect(() => {
    if(isPlatform('hybrid')) {
      Keyboard.addListener('keyboardDidShow', info => {
        setKeyboardVisible(true);
      });  
      // Keyboard.addListener('keyboardDidHide', () => {
      //   setKeyboardVisible(false);
      // });
    } else {
      window.addEventListener('ionKeyboardDidShow', () => {
        setKeyboardVisible(true);
      });
      // window.addEventListener('ionKeyboardDidHide', () => {
      //   setKeyboardVisible(false);
      // });
    }
    return () => {
      if(isPlatform('hybrid')) {
        Keyboard.removeAllListeners();
      } else {
        window.removeEventListener('ionKeyboardDidShow', ()=>{});
        window.removeEventListener('ionKeyboardDidHide', ()=>{});
      }
    }
  }, [])
  

  const saveAndNewPrayer = async () => {
    await savePrayer();
    setIsNewPrayer(true);
    setSelectedPrayer(newPrayer);
    setCreatedDate(newPrayer.createdDate)
    setSelectPrayerStatus(newPrayer.status);
    setPrayerTitle(newPrayer.title);
    setPrayerDescription(newPrayer.description);
    setHideShareAndDeleteLink(true);
  }

  const savePrayer = async () => {
    const today = new Date(Date.now());  
    const currentPrayer: IPrayer = { ...selectedPrayer,
      title: prayerTitle,
      description: prayerDescription,
      status: selectPrayerStatus as PrayerStatusValues,
      modifiedDate: today,
      linkedPostId: selectedPrayer.linkedPostId ? selectedPrayer.linkedPostId : '',
    };

    if(isNewPrayer){
      await PrayerService.createPrayer(currentPrayer).then(result => {
        if(result.Success) {
          setIsNewPrayer(false);
          setSelectedPrayer(result.Data!);
          setToastSuccessMessage(result.Message.UserMessage);
          setDisplayToastSuccess(true);
          setHideShareAndDeleteLink(false);
        } else {
          setDisplayToastFailed(true);
        }
      });
    } else {
      await PrayerService.updatePrayer(currentPrayer).then(result => {
        if(result.Success) {
          setSelectedPrayer(currentPrayer);
          setToastSuccessMessage(result.Message.UserMessage)
          setDisplayToastSuccess(true);
        } else {
          setDisplayToastFailed(true);
        }
      });
    }  
  }

  const deletePrayer = () => {
    // We don't completely remove prayer record so that cloud sync will work
    const deletedPrayer = {...selectedPrayer, 
      title: '',
      description: '',
      answer: '',
      note: '',
      status: PrayerStatus.deleted,
      modifiedDate: new Date(Date.now()),
    }
    PrayerService.updatePrayer(deletedPrayer).then(result => {
      if(result.Success) {
        setIsNewPrayer(true);
        setSelectedPrayer(newPrayer);
        setCreatedDate(newPrayer.createdDate)
        setSelectPrayerStatus(newPrayer.status);
        setPrayerTitle(newPrayer.title);
        setPrayerDescription(newPrayer.description);
        setHideShareAndDeleteLink(true);
        // For some reason after returning to page after deleting the page wouldn't load properly again.
        // the db query would fail to return a result therefor this code was commented out for now.
        //history.push(AppRouteInfo[AppRouteKeys.MyPrayers].path);
      }
    });
  }

  const sharePrayer = () => {
    let sharePath = AppRouteInfo[AppRouteKeys.FellowshipCreatePost].path;
    sharePath = sharePath.replace(':postType?', PostTypes.prayer.toString());
    sharePath = sharePath.replace(':shareIdentifier?', selectedPrayer.id.toString());
    history.push(sharePath, {direction: 'forward'});
  }

  const dismissMessage = (messageId: string, initiateAction: boolean) => {
    const dismissMessage: IDismissibleMessage = {
      messageId,
      category: props.title,
      timesDisplayed: 1,
      dateDisplayed: new Date(Date.now()),
      dismissed: true,
    }
    DismissibleMessageService.logDismissibleMessage(dismissMessage);
    setHidePrayStorageMessage(true);
  }

  const pageHeaderMenuContent = 
    <IonList className="prayer-page-menu-list">
      <IonItem className="header-menu-item" onClick={savePrayer}>
        <IonLabel>SAVE</IonLabel>
        <IonIcon slot="end" icon={save}></IonIcon>
      </IonItem>
      <IonItem className="header-menu-item" onClick={saveAndNewPrayer}>
        <IonLabel>{`SAVE & CREATE NEW`}</IonLabel>
        <IonIcon slot="end" icon={save}></IonIcon>
      </IonItem>
      <IonItem onClick={sharePrayer}
        className={!LoggedIn || hideShareAndDeleteLink ? 'header-menu-item hidden' : 'header-menu-item'}>
        <IonLabel>SHARE</IonLabel>
        <IonIcon slot="end" icon={share}></IonIcon>
      </IonItem>
      <IonItem onClick={deletePrayer}
        className={hideShareAndDeleteLink ? 'header-menu-item hidden' : 'header-menu-item'}>
        <IonLabel>DELETE</IonLabel>
        <IonIcon slot="end" icon={trashBin}></IonIcon>
      </IonItem>
    </IonList>;

  return (
    <IonPage>
      <PageHeader {...props} showBackButton={true} menuContents={pageHeaderMenuContent}></PageHeader>
      <IonContent className="update-prayer-content">
        <DismissibleCard
          messageId={AppMessages.prayerStorage.messageId}
          hideCard={hidePrayStorageMessage}
          buttonText="I understand"
          color="prayer"
          dismissCard={dismissMessage}
        >
          {AppMessages.prayerStorage.messageBody}
        </DismissibleCard>
        <IonGrid onKeyDown={(e)=>{
          if(e.keyCode === 83  && e.ctrlKey) {
            e.preventDefault();
            savePrayer();
          }}} className="update-prayer-grid">
          <IonRow className="update-prayer-save-share">
            <IonCol className="txt-left">
              <IonText color="secondary"
                onClick={sharePrayer}
                className={!LoggedIn || hideShareAndDeleteLink ? 'prayer-button-label hidden' : 'prayer-button-label'}>SHARE</IonText>
            </IonCol>
            <IonCol className="txt-right">
              <IonText color="secondary" className="prayer-button-label" onClick={savePrayer}>SAVE</IonText>
            </IonCol>
          </IonRow>
          <IonRow className="update-prayer-title-container">
            <IonCol>
              <IonItem>
                <IonLabel position="stacked" color="medium">TITLE:</IonLabel>
                <IonInput aria-label="TITLE" className="update-prayer-title" value={prayerTitle} onIonChange={e => setPrayerTitle(e.detail.value?.toString()!)} autoCapitalize='sentences'
                  onFocus={e => !isPlatform('desktop') && setKeyboardVisible(true)} onBlur={e => setKeyboardVisible(false)} tabIndex={0}></IonInput>
              </IonItem>
            </IonCol>
          </IonRow>
          <IonRow
            className="update-prayer-description-row"
            ref={descriptionContainer}>
            <IonCol className="update-prayer-description-container">
              <IonItem lines="none" className="update-prayer-title-container">
                <IonLabel position="stacked" color="medium">DESCRIPTION:</IonLabel>
                <IonTextarea aria-label="DESCRIPTION" className="update-prayer-description" value={prayerDescription} 
                  autoCapitalize='sentences'
                  onIonChange={e => setPrayerDescription(e.detail.value?.toString()!)} 
                  onFocus={e => !isPlatform('desktop') && setKeyboardVisible(true)} onBlur={e => setKeyboardVisible(false)}
                  autoGrow={true}></IonTextarea>
              </IonItem>
            </IonCol>
          </IonRow>
        </IonGrid>
        <IonToast color="success"
          isOpen={displayToastSuccess}
          onDidDismiss={() => setDisplayToastSuccess(false)}
          message={toastSuccessMessage}
          duration={2500} />
        <IonToast color="danger"
          isOpen={displayToastFailed}
          onDidDismiss={() => setDisplayToastFailed(false)}
          message="Error: Failed to Update Prayer List."
          duration={2500} />
      </IonContent>
      <IonFooter className="update-prayer-footer">
        <IonGrid className={keyboardVisible ? 'update-prayer-hidden' : ''}>
          <IonRow>
            <IonCol>
              <IonSegment mode="md" value={selectPrayerStatus}
                onIonChange={e => (e.detail.value?.toString() ? setSelectPrayerStatus(e.detail.value?.toString() as PrayerStatusValues) : '')}
                color={AppRouteInfo[AppRouteKeys.MyPrayers].themeColorName}
                className="pray-status-selector">
                <IonSegmentButton value={PrayerStatus.revisit}>
                  <IonLabel>{PrayerStatusNames[PrayerStatus.revisit]}</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value={PrayerStatus.active}>
                  <IonLabel>{PrayerStatusNames[PrayerStatus.active]}</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value={PrayerStatus.answered}>
                  <IonLabel>{PrayerStatusNames[PrayerStatus.answered]}</IonLabel>
                </IonSegmentButton> 
              </IonSegment>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-center prayer-created-date-footer">
              <IonText color="medium" className="prayer-button-label">CREATED DATE: {createdDate ? createdDate.toLocaleDateString() : ''}</IonText>
              <div className="prayer-ios-safe-zone"></div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonFooter>
    </IonPage>
  );
};

export default PrayerUpdate;
